document.addEventListener( 'DOMContentLoaded', fixHeader );
window.addEventListener( 'scroll', fixHeader );
function fixHeader() {
  const scrollPos = window.scrollY;
  if ( scrollPos > 0 ) {
    document.querySelector( 'body' ).classList.add( 'fix-header' );
  } else {
    document.querySelector( 'body' ).classList.remove( 'fix-header' );
  }
}